import { FC } from "react";
import { Section } from "@/components/Html/Section";

interface Props {
  no: string;
  text: string;
}

export const Item: FC<Props> = ({ no, text }) => {
  return (
    <Section className="flex w-full items-center gap-[12px] rounded-[24px] bg-white px-[24px] py-[16px]">
      <span className="flex-none text-[64px] font-bold text-[#FFDAD5]">{no}</span>
      <span>{text}</span>
    </Section>
  );
};
